import * as fromViewColReducers from './view-col.reducers';
import * as fromSideNavReducers from './side-nav.reducers';
import * as fromTranslationReducers from './translation.reducers';

import { ActionReducerMap } from '@ngrx/store';
import { AppStates } from '../states';

export const appReducers: ActionReducerMap<AppStates> = {
  viewColState: fromViewColReducers.reducer,
  sideNavState: fromSideNavReducers.reducer,
  translationState: fromTranslationReducers.reducer
};
